import AttachFileIcon from "@mui/icons-material/AttachFileOutlined";
import { DragEvent, useState } from "react";
import styles from "./FileInput.module.css";

function FileInput({ name, onFilesSelected, setTouched }: IFileInputProps) {
    const [isDragOver, setIsDragOver] = useState(false);

    const onDrop = (e: DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        setIsDragOver(false);

        const files = Array.from(e.dataTransfer.files);
        if (files.length)
            onFilesSelected(files);
    };

    return (
        <label
            className={[styles.container, isDragOver ? styles.dragOver : ""].join(" ")}
            onDragOver={e => {
                e.preventDefault();
                setIsDragOver(true);
            }}
            onDragLeave={() => setIsDragOver(false)}
            onDrop={onDrop}
        >
            <AttachFileIcon className={styles.icon} />
            <input
                name={name}
                type="file"
                multiple
                value=""
                onChange={e => onFilesSelected(Array.from(e.target.files!))}
                onBlur={setTouched}
            />
        </label>
    );
}

export default FileInput;

interface IFileInputProps {
    name?: string;
    onFilesSelected: (files: File[]) => void;
    setTouched?: {
        (e: React.FocusEvent<any, Element>): void;
        <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
    };
}
